import { useState, useEffect } from "react";

import { useShow } from "@pankod/refine-core";
import {
  Create,
  Edit,
  Show,
  Typography,
  Button,
  Grid,
} from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";
import { useNavigation } from "@pankod/refine-core";
import { toast } from "react-toastify";
import useLocales from "locales/useLocales";
import { allLangs } from "locales/config";
import axios from "utils/axios";
import { separatePrimitiveAndObjectFields } from "utils/utils";

export default function Comp({
  isCreate,
  isShow = false,
  Fields,
  label,
  routeName,
  parentName,
  defaultLangOnly = false,
  queryParams = { populate: "deep,3" },
}) {
  const { currentLang, defaultLang } = useLocales();
  const [localeExists, setLocaleExists] = useState(true);
  const [localizedContent, setLocalizedContent] = useState(true);
  const [defaultLocaleData, setDefaultLocaleData] = useState(null);

  const {
    refineCore: { formLoading, queryResult },
    saveButtonProps,
    register,
    control,
    formState: { errors, isValid },
    getValues,
    setError,
    setValue,
    watch,
  } = useForm({
    refineCoreProps: {
      mode: "onChange",
      metaData: {
        ...queryParams,
        fakeParam: defaultLangOnly ? defaultLang : currentLang.value, //this is to force re-fetching data when language changes
      },
    },
  });

  const { data, isLoading } = useShow({
    metaData: {
      ...queryParams,
      //test con populate specifico per i booking
      /*populate: {
        booking_items: {
          populate: {
            accommodation: {
              populate: ["localizations"],
            },
            prenotazione: true,
            prezziario: true,
            rate_plan: {
              populate: ["localizations"],
            },
            treatment: true,
          },
        },
        booking_payments: {
          populate: ["connected_resource"],
        },
        coupon: true,
        extras: true,
        facility: true,
        user: true,
      },*/
      fakeParam: defaultLangOnly ? defaultLang : currentLang.value, //this is to force re-fetching data when language changes
    },
  }); //serve per costringere Show a fare il fetch dei dati
  const { push } = useNavigation();

  const path = parentName ? `${parentName}/${routeName}` : `${routeName}`;

  /*useEffect(() => {
    if (!isCreate && !formLoading && queryResult?.data?.data?.id) {
      let localizations = queryResult.data.data.localizations;
      console.log(queryResult.data.data);
      if (!localizations) {
        // this content type is not localized
        setDefaultLocaleData(queryResult.data.data);
        setLocaleExists(false);
        setLocalizedContent(false);
        return;
      }

      if (queryResult.data.data.locale == currentLang.value) {
        setLocaleExists(queryResult.data.data);
        if (queryResult.data.data.locale == defaultLang) {
          setDefaultLocaleData(queryResult.data.data);
        } else {
          let defLang = localizations.find((l) => l.locale == defaultLang);
          if (defLang)
            axios
              .get(`/api/${routeName}/${defLang.id}?populate=deep,2`)
              .then((res) => {
                setDefaultLocaleData(normalizeData(res.data));
              })
              .catch((err) => {
                console.log(err);
                toast.error("Something went wrong");
              });
        }
      } else {
        let languageExists = (localizations || []).find(
          (l) => l.locale == currentLang.value
        );
        if (languageExists) {
          window.open(`/${path}/edit/${languageExists.id}`, "_self");
        }
        setLocaleExists(languageExists);
      }
    }
  }, [currentLang.value, formLoading]);*/

  const handleCreate = async (e, values) => {
    e.preventDefault();
    try {
      // separate primitives and arrays and objects
      let { primitives, arraysAndObjects } =
        separatePrimitiveAndObjectFields(values);

      // create default language
      let { data } = await axios.post(`/api/${routeName}`, {
        data: {
          ...primitives,
          ...arraysAndObjects,
        },
      });

      //check if data returned was already flattened in backend. If not find the id nested in data.data
      var ID = data?.id ? data.id : data.data.id;

      // create all the localizations
      if (!defaultLangOnly) {
        for (let lang of allLangs) {
          if (lang.value != defaultLang) {
            try {
              let { data: newLang } = await axios.post(
                `/api/${routeName}/${ID}/localizations`,
                {
                  locale: lang.value,
                  ...primitives,
                }
              );
            } catch (error) {
              console.log("Localization Error", error);
              toast.error("Problemi nella gestione del multilingua");
            }
          }
        }
      }
      // open the selected language entry
      //push(`/${path}/edit/${currentLangEntry.id}`, "_self");
      toast.success("Creazione avvenuta con successo!");
      push(`/${path}`, "_self"); //redirect to list page
    } catch (error) {
      console.log("Create Error", error);
      if (error.error.status == 500 || error.error.status == 400) {
        toast.error(
          "Riempire i campi obbligatori in tutti i pannelli prima di salvare"
        );
      } else {
        toast.error("Something went wrong while creating entry");
      }
    }
  };

  const handleEdit = async (e, values) => {
    e.preventDefault();

    try {
      //collect all localization ids
      let data = queryResult.data.data;
      let ids = [{ id: data.id, locale: defaultLang }];
      if (data.localizations)
        for (let locale of data.localizations)
          ids.push({ id: locale.id, locale: locale.locale });

      //separate primitives and arrays and objects
      let { primitives, arraysAndObjects } =
        separatePrimitiveAndObjectFields(values);

      //collect all localized fields by scanning through the input and textarea tags in the DOM
      let localizedFields = [];
      let inputs = document.getElementsByTagName("input");
      let textareas = document.getElementsByTagName("textarea");
      for (let element of inputs) {
        let name = element.getAttribute("name");
        let localized = element.getAttribute("data-localized") == "true";
        if (localized) localizedFields.push(name);
      }
      for (let element of textareas) {
        let name = element.getAttribute("name");
        let localized = element.getAttribute("data-localized") == "true";
        if (localized) localizedFields.push(name);
      }

      const filteredKeys = Object.keys(values).filter(
        (item) => !localizedFields.includes(item)
      );
      const nonLocalizedData = {};
      filteredKeys.forEach((item) => (nonLocalizedData[item] = values[item]));
      //console.log("localized ", localizedData);
      //console.log("nonLocalized ", nonLocalizedData);

      const nonLocalizedPrimitives = {};
      const nonLocalizedPrimitiveKeys = Object.keys(primitives).filter(
        (item) => !localizedFields.includes(item)
      );
      nonLocalizedPrimitiveKeys.forEach(
        (item) => (nonLocalizedPrimitives[item] = values[item])
      );

      //put data to all ids
      for (let id of ids) {
        //console.log(id.locale);
        //create payload
        let payload = {};
        if (currentLang.value == defaultLang) {
          if (id.locale == defaultLang) {
            payload = values;
            //console.log(payload);
          } else {
            payload = nonLocalizedPrimitives;
            //console.log(payload);
          }
        } else {
          if (id.locale == defaultLang) {
            payload = nonLocalizedData;
            //console.log(payload);
          } else {
            if (id.locale == currentLang.value) {
              payload = primitives;
              //console.log(payload);
            } else {
              payload = nonLocalizedPrimitives;
              //console.log(payload);
            }
          }
        }

        //send PUT request
        let { data } = await axios.put(`/api/${routeName}/${id.id}`, {
          data: payload,
        });
      }
      toast.success("Modifica avvenuta con successo!");
      push(`/${path}`, "_self"); //redirect to list page
    } catch (error) {
      console.log("Edit Error", error);
      toast.error("Something went wrong while editing entries");
    }
  };

  if (isCreate) {
    return (
      <Create
        isLoading={formLoading}
        saveButtonProps={{
          onClick: (e) => handleCreate(e, getValues()),
          disabled: !isValid,
        }}
        title={<Typography variant="h5">Crea {label}</Typography>}
      >
        <Fields
          register={register}
          control={control}
          errors={errors}
          getValues={getValues}
          setError={setError}
          setValue={setValue}
          watch={watch}
          disabled={false}
          isCreate={isCreate}
        />
      </Create>
    );
  } else {
    if (!localeExists && localizedContent) {
      return (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ height: "100%" }}
        >
          <Grid item>
            <Typography variant="h6" gutterBottom component="div">
              Questo record non esiste nella lingua selezionata. Importa il
              record da quello già esistente
            </Typography>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                axios
                  .post(
                    `/api/${routeName}/${queryResult?.data?.data?.id}/localizations`,
                    {
                      locale: currentLang.value,
                    }
                  )
                  .then((res) => {
                    console.log(res.data);
                    window.open(`/${path}/edit/${res.data.id}`, "_self");
                  })
                  .catch((err) => {
                    console.log(err);
                    toast.error("Something went wrong");
                  });
              }}
            >
              Importa
            </Button>
          </Grid>
        </Grid>
      );
    }

    if (isShow)
      return (
        <Show
          isLoading={isLoading}
          title={<Typography variant="h5">Visualizza {label}</Typography>}
          headerButtons={() => {}}
        >
          <Fields
            defaultLanguageRecord={defaultLocaleData}
            register={register}
            control={control}
            errors={errors}
            getValues={getValues}
            setError={setError}
            setValue={setValue}
            watch={watch}
            disabled={true}
            isCreate={isCreate}
          />
        </Show>
      );

    return (
      <Edit
        isLoading={formLoading}
        saveButtonProps={{
          onClick: (e) => handleEdit(e, getValues()),
          disabled: !isValid,
        }} //{saveButtonProps}
        title={<Typography variant="h5">Modifica {label}</Typography>}
        headerButtons={() => {}}
      >
        <Fields
          defaultLanguageRecord={defaultLocaleData}
          register={register}
          control={control}
          errors={errors}
          getValues={getValues}
          setError={setError}
          setValue={setValue}
          watch={watch}
          disabled={false}
          isCreate={isCreate}
        />
      </Edit>
    );
  }
}
